import { createFileRoute } from '@tanstack/react-router'
import Webhook from 'Integration/components/Webhook'

export const Route = createFileRoute('/integrations/_webhooks/webhook/')({
    component: Webhook,
})
